import { css } from '@emotion/css'
import { breakpoint, colors, fontWeight, mediaQueryHelper } from '@offerzen/pinata'

const styles = {
  pricingContainer: css({
    backgroundColor: colors.white,
    color: '#132254',
    padding: '40px 24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'auto',
    margin: '0 auto',
    gap: '24px',

    [mediaQueryHelper(breakpoint.phone)]: {
      maxWidth: '1100px',
      height: '100%',
      padding: '40px',
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      flexDirection: 'row',
      padding: '100px 40px',
      alignItems: 'start',
    },
  }),

  leftCol: css({
    maxWidth: 'none',
    width: '100%',
    textAlign: 'left',

    [mediaQueryHelper(breakpoint.tablet)]: {
      textAlign: 'center',
      width: '90%',
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      textAlign: 'left',
      width: '100%',
    },
  }),

  title: css({
    fontSize: '32px',
    marginBottom: '16px',
    marginTop: '0px',
    lineHeight: '120%',
    fontWeight: fontWeight.bold,

    [mediaQueryHelper(breakpoint.desktop)]: {
      fontSize: '48px',
    },
  }),

  blueTitle: css({
    color: colors.cornflowerBlue,
    whiteSpace: 'break-spaces',
  }),

  subtitle: css({
    color: colors.scorpion,
    marginBottom: '0',
    fontSize: '20px',
    lineHeight: '26px',
    fontWeight: fontWeight.medium,

    [mediaQueryHelper(breakpoint.desktop)]: {
      marginBottom: '32px',
    },
  }),

  rightCol: css({
    width: '100%',

    [mediaQueryHelper(breakpoint.tablet)]: {
      margin: '0 auto',
    },
  }),

  list: css({
    width: 'auto',
    maxWidth: '100%',
    marginLeft: 0,

    [mediaQueryHelper(breakpoint.desktop)]: {
      maxWidth: '602px',
    },
  }),

  listItem: css({
    display: 'flex',
    marginBottom: '24px',
    alignItems: 'center',
    position: 'relative',

    '& p': {
      margin: '0 0 0 24px',
      fontSize: '20px',
      color: '#0e204b',
      fontWeight: fontWeight.semiBold,
    },
  }),

  listImage: css({
    width: '32px',
    height: '32px',
    display: 'inline-block',
  }),

  listAction: css({
    fontSize: '20px',
    color: colors.scorpion,

    '& strong': {
      color: '#0b1236',
      fontWeight: fontWeight.bold,
    },
  }),

  listActionButton: css({
    color: colors.cornflowerBlue,
    fontSize: '20px',
    cursor: 'pointer',
  }),

  mainButton: css({
    display: 'block',
    width: 'auto',
    maxWidth: '100%',
    margin: 0,
    padding: '15px 24px',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    alignItems: 'center',
    alignSelf: 'auto',
    borderRadius: '4px',
    backgroundColor: '#5EA5EE',
    opacity: 1,
    transition:
      'transform .2s cubic-bezier(.55, .085, .68, .53),background-color 150ms cubic-bezier(.55, .085, .68, .53),box-shadow .2s,-webkit-transform .2s cubic-bezier(.55, .085, .68, .53)',
    color: colors.white,
    fontSize: '16px',
    lineHeight: '100%',
    fontWeight: '600',
    textAlign: 'center',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    cursor: 'pointer',

    '&:hover, &:focus': {
      boxShadow: '0px 4px 4px rgba(19, 34, 84, 0.15)',
      backgroundColor: '#2E71C1',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      margin: '0 auto',
      maxWidth: '115px',
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      margin: 'inherit',
    },
  }),

  desktopButton: css({
    display: 'none',

    [mediaQueryHelper(breakpoint.desktop)]: {
      display: 'block',
    },
  }),

  mobileButton: css({
    display: 'block',
    width: '100%',
    maxWidth: 'auto',

    [mediaQueryHelper(breakpoint.desktop)]: {
      display: 'none',
    },
  }),
}

export default styles
